import { BeneficialOwner, SingleInvoice } from '~/Interfaces';
import { ApiStatus } from './sharedTypes';

export const FETCH_SINGLE_INVOICE = 'FETCH_SINGLE_INVOICE';
export const SET_API_INVOICE_STATUS = 'SET_API_INVOICE_STATUS';
export const CONFIRM_SPLIT_PAYMENT_STARTED = 'CONFIRM_SPLIT_PAYMENT_STARTED';
export const CONFIRM_SPLIT_PAYMENT_SUCCESS = 'CONFIRM_SPLIT_PAYMENT_SUCCESS';
export const CONFIRM_SPLIT_PAYMENT_FAILED = 'CONFIRM_SPLIT_PAYMENT_FAILED';
export const CONFIRM_SPLIT_PAYMENT_IDLE = 'CONFIRM_SPLIT_PAYMENT_IDLE';
export const CHOOSE_PAYMENT_METHOD_STARTED = 'CHOOSE_PAYMENT_METHOD_STARTED';
export const CHOOSE_PAYMENT_METHOD_SUCCESS = 'CHOOSE_PAYMENT_METHOD_SUCCESS';
export const CHOOSE_PAYMENT_METHOD_FAILED = 'CHOOSE_PAYMENT_METHOD_FAILED';
export const CHOOSE_PAYMENT = 'CHOOSE_PAYMENT';
export const SET_UBO_API_STATUS = 'SET_UBO_API_STATUS';
export const SET_SIGNICAT_STATUS = 'SET_SIGNICAT_STATUS';
export const UPDATE_UBO = 'UPDATE_UBO';
export const UPDATE_DEBTOR_INVOICES = 'UPDATE_DEBTOR_INVOICES';
export const SET_API_DEBTOR_INVOICES_STATUS = 'SET_API_DEBTOR_INVOICES_STATUS';

interface GetSingleInvoice {
  type: typeof FETCH_SINGLE_INVOICE;
  payload: SingleInvoice;
}

interface UpdateInvoiceStatusAction {
  type: typeof SET_API_INVOICE_STATUS;
  payload: ApiStatus;
}

interface ConfirmSplitPaymentActionStarted {
  type: typeof CONFIRM_SPLIT_PAYMENT_STARTED;
  payload: { externalId?: string };
}
interface ConfirmSplitPaymentActionSuccess {
  type: typeof CONFIRM_SPLIT_PAYMENT_SUCCESS;
  payload: { externalId?: string };
}
interface ConfirmSplitPaymentActionFailed {
  type: typeof CONFIRM_SPLIT_PAYMENT_FAILED;
  payload: { externalId?: string };
}
interface ConfirmSplitPaymentActionIdle {
  type: typeof CONFIRM_SPLIT_PAYMENT_IDLE;
  payload: { externalId?: string };
}
interface ChoosePaymentMethodStarted {
  type: typeof CHOOSE_PAYMENT_METHOD_STARTED;
  payload: { externalId?: string };
}
interface ChoosePaymentMethodSuccess {
  type: typeof CHOOSE_PAYMENT_METHOD_SUCCESS;
  payload: { externalId?: string };
}
interface ChoosePaymentMethodFailed {
  type: typeof CHOOSE_PAYMENT_METHOD_FAILED;
  payload: { externalId?: string };
}
interface SetUboApiStatusAction {
  type: typeof SET_UBO_API_STATUS;
  payload: ApiStatus;
}
interface ChoosePaymentAction {
  type: typeof CHOOSE_PAYMENT;
  payload: ApiStatus;
}
interface SetSignicatStatusAction {
  type: typeof SET_SIGNICAT_STATUS;
  payload: ApiStatus;
}

interface UpdateUboAction {
  type: typeof UPDATE_UBO;
  payload: {
    beneficialOwners: BeneficialOwner[];
    beneficialOwnersChanged: boolean;
  };
}
interface UpdateDebtorInvoicesAction {
  type: typeof UPDATE_DEBTOR_INVOICES;
  payload: { invoices: SingleInvoice[]; concat: boolean; count: number };
}
interface SetApiDebtorInvoicesStatusAction {
  type: typeof SET_API_DEBTOR_INVOICES_STATUS;
  payload: ApiStatus;
}

export type InvoiceActon =
  | GetSingleInvoice
  | UpdateInvoiceStatusAction
  | ConfirmSplitPaymentActionStarted
  | ConfirmSplitPaymentActionSuccess
  | ConfirmSplitPaymentActionFailed
  | ConfirmSplitPaymentActionIdle
  | ChoosePaymentMethodStarted
  | ChoosePaymentMethodSuccess
  | ChoosePaymentMethodFailed
  | SetUboApiStatusAction
  | SetSignicatStatusAction
  | ChoosePaymentAction
  | UpdateUboAction
  | UpdateDebtorInvoicesAction
  | SetApiDebtorInvoicesStatusAction;
